export const messages = {
  en: {
    printEquipmentAccount: {
      machineId: 'Equipment ID',
      printTime: 'Print Time',
      equipmentLabel: 'Equipment Label',
      project: 'Project',
      locationName: 'Location Name',
      machineName: 'Machine Name',
      importanceLevel: 'Importance Level',
      systemName: 'System Name',
      enableDate: 'Enable Date',
      machineBrand: 'Machine Brand',
      specificationModel: 'Specification Model',
      code: 'Code',
      responsiblePerson: 'Responsible Person'
    }
  },
  zh: {
    printEquipmentAccount: {
      machineId: '设备ID',
      printTime: '打印时间',
      equipmentLabel: '设备标签',
      project: '项目',
      locationName: '位置名称',
      machineName: '设备名称',
      importanceLevel: '重要等级',
      systemName: '系统名称',
      enableDate: '启用日期',
      machineBrand: '设备品牌',
      specificationModel: '规格型号',
      code: '编码',
      responsiblePerson: '责任人'
    }
  }
}